import { useContext } from 'react';
import { DisclosureStateContext } from 'react-aria-components';
import { msg } from '@gonfalon/messages/msg';
import { Button } from '@launchpad-ui/components';

export const AlertCollapsibleTrigger = () => {
  const state = useContext(DisclosureStateContext);
  return (
    <div className="u-mt-s">
      <Button slot="trigger" variant="minimal" data-test-id="collapsible-trigger">
        {msg('ui.alertCollapsible.toggle', { isExpanded: state?.isExpanded ? 'true' : 'false' })}
      </Button>
    </div>
  );
};
